import {
   MindfulnessStarter,
  DailyPresense,
  ConsistancyBuilder,
  WeeklyMindfulness,
  HabitFormed,
  MindfullnessChampion,
} from "@utils/defaultImages";

export const mindfulnessSliderData = [
    {
      RankImage: MindfulnessStarter,
      title: "Mindful Starter",
      unlockDate: "Unlocked on 5th July",
      description: "Earned when you complete your first mindfulness practice and mark it as done.",
    },
    {
      RankImage: DailyPresense,
      title: "Daily Presence",
      unlockDate: "Unlocked on 5th July",
      description: "Awarded when you mark daily advice as done on 3 separate days (not necessarily consecutive).",
    },
    {
      RankImage: ConsistancyBuilder,
      title: "Consistency Builder",
      unlockDate: "Unlocked on 5th July",
      description:
        "Awarded when you Mark daily mindfulness advice as done for 5 days in a row.",
    },
    {
      RankImage: WeeklyMindfulness,
      title: "Weekly Mindfulness Goal",
      unlockDate: "Unlocked on 5th July",
      description:
        "Achieved when you complete 5 mindfulness practices within a single week.",
    },

    {
      RankImage: HabitFormed,
      title: "Mindful Habit Formed",
      unlockDate: "Unlocked on 5th July",
      description: "Achieved when you Complete mindfulness practices on 10 total days (can be non-consecutive).",
    },
    {
      RankImage: MindfullnessChampion,
      title: "Mindfulness Champion",
      unlockDate: "Unlocked on 5th July",
      description:
        "Achieved when you Complete 20+ mindfulness practices(can be non-consecutive).",
    },
  ];